import {
  CREATE_DOCTOR_INIT,
  CREATE_DOCTOR_SUCCESS,
  CREATE_DOCTOR_FAIL
} from "../actions/type";

const initialState = {
  loading: false,
  error: null,
  data: null
};

const createDoctorReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DOCTOR_INIT:
      return {
        ...state,
        loading: true,
        error: null,
        data: null
      };
    case CREATE_DOCTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload
      };
    case CREATE_DOCTOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: null
      };
    default:
      return state;
  }
};

export default createDoctorReducer;

